
<template>
    <div 
        class="rate-comparison" 
        :class="{'is-active': theData.active}">
        <div class="container">
            <div class="rate-comparison__wrapper">
                <div class="row">
                    <div class="col-12">
                        <!-- Begin: Table Header -->
                        <div class="flex-table general-membership">
                            <span 
                                class="flex-table__cell flex-table__heading-cell" 
                                :class="columnCountClass" 
                                v-on:click="theData.active = !theData.active">
                                <span 
                                    v-if="theData.tableName.preTitle" 
                                    class="flex-table__category-label" 
                                    v-html="theData.tableName.preTitle"></span>
                                <h2 class="flex-table__table-title" 
                                    v-html="theData.tableName.title"></h2>
                            </span>

                            <span v-for="(item, index) in theData.rateText" 
                                :key="index" 
                                class="flex-table__cell flex-table__labels-cell">
                                <span class="general-membership__rate-label" v-html="item.title"> </span>

                                <span class="general-membership__date-label" v-html="item.date"></span>
                            </span>
                        </div>
                        <!-- End:   Table Header -->

                        
                        <div class="flex-table__content-group">
                            <!-- Begin: "table" -->
                            <div v-for="(tableRow, index) in theData.rowData" 
                                :key="index"
                                class="flex-table general-membership" 
                                :class="{'collapsed': !tableRow.active}" >
                                <div 
                                    v-on:click="tableRow.active = !tableRow.active" 
                                    class="flex-table__cell flex-table__cell--head" 
                                    :class="columnCountClass">
                                    <span class="row-title" v-html="tableRow.rowTitle"></span>

                                    <span v-if="tableRow.rowDescription" class="row-description d-none d-md-block" 
                                    v-html="tableRow.rowDescription"></span>
                                </div>

                                <span 
                                    v-for="(rate, rateIndex) in tableRow.rates" 
                                    :key="rateIndex" 
                                    class="flex-table__cell">
                                    <div class="row">
                                        <div class="col-6 md-d-none general-membership__mobile-label" >
                                            <span class="general-membership__mobile-label-top" v-html="theData.rateText[rateIndex].title"></span>

                                            <span class="general-membership__mobile-label-bottom" v-html="theData.rateText[rateIndex].date"></span>
                                        </div>

                                        <div 
                                            :class="rate.gold ? 'col-3 col-md-6' : 'col-6 col-md-12'" 
                                            class="general-membership__value">
                                            {{ rate.normal }}
                                        </div>

                                        <div 
                                            v-if="rate.gold"
                                            class="col-3 col-md-6 general-membership__value general-membership__value--gold" 
                                            :class="{
                                                'show-label': index === 0 && rate.gold, 'm-show-label': rate.gold
                                                }">
                                            {{ rate.gold }}
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <!-- End:   "table" -->
                        </div>

                        <!-- postTableContent rich text content removed from the tableData object and passed in to this slot to resolve IE11 issues with handleing spaces in the rich text content. -->
                        <!-- postTableContent Content - - - - - -->
                        <slot name="postTableContent"></slot>
                        <!-- // End postTableContent content - -->

                    </div>
                </div>
            </div>
        </div>    
    </div>    
</template>

<script>
    export default {
        props: {
            tableData: {
                // example data can be found:
                // demo\pages\components\phd-membership-rate-comparison.vue
                type: Object,
                required: true
            }
        },
        data() {
            return {
                theData: {}
            }
        },
        beforeMount() {
            this.theData = this.tableData;
        },
        computed: {
            numberOfDataColumns() {
                let count = this.theData.rateText.length;

                return count;
            },
            columnCountClass() {
                let className = '';
                
                switch(this.numberOfDataColumns) {
                    case 1:
                        className = "data-column-count--one";
                        break;
                    case 2:
                        className = "data-column-count--two";
                        break;
                }

                return className;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/membership-rate-comparison.vue